<template>
  <div
    class="d-flex align-items-center mb-4 step"
    :class="{ complete: currentStep > id }"
  >
    <span class="step-counter mr-3" :class="{ active: currentStep === id }">
      <span v-show="currentStep > id">
        <i class="fas fa-check text-success"></i>
      </span>
      <span v-show="currentStep <= id">{{ id }}</span>
    </span>
    <div class="step-info">
      <div class="font-jumperbold">{{ $cte(title) }}</div>
      <div class="text-muted">{{ $cte(description) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentStep: Number,
    id: Number,
    title: String,
    description: String,
  },
};
</script>

<style scoped lang="scss">
@import "./variables";

.step {
  pointer-events: none;

  &.complete {
    color: #252734;
    pointer-events: none;
  }
}

.step-counter {
  display: block;
  width: 50px;
  min-width: 50px;
  line-height: 50px;
  height: 50px;
  background: $light-green;
  color: #84A369;
  text-align: center;
  border-radius: 50%;
  &.active {
    color: #000;
    background-color: $green;
  }
}
</style>
